<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center">
          <form class="search-box position-relative" @submit.prevent="handleSearch">
            <input type="text" class="form-control shadow-none text-black rounded-0 border-0" placeholder="Search task type"
              v-model="searchQuery" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <router-link to="/add-task-type" v-if="allowAdd"
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
            Add Task Type
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </router-link>
          <select class="project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10" v-model="pageSize" @change="fetchTaskTypes(searchQuery)">
            <option :value="5">5</option>
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
          </select>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Task Type
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="taskType in filteredTaskTypes" :key="taskType.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ taskType.taskName }}
                </th>
                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                <div class="dropdown">
                  <button v-if="allowAdd" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="openTaskCustomFieldPage(taskType.id)">
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                        Update Custom Fields
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="#" @click.prevent="deleteTaskType(taskType.id)"
                        ><i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Delete</a
                      >
                    </li>
                  </ul>
                </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredTaskTypes.length }}</span> out of
            <span class="fw-bold">{{ totalTaskTypes }}</span> results
          </p>
          <nav class="mt-15 mt-md-0">
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: pageIndex === 1 }">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="changePage(pageIndex - 1)">
                  <i class="flaticon-chevron-1"></i>
                </a>
              </li>
              <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: page === pageIndex }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
              </li>
              <li class="page-item" :class="{ disabled: pageIndex === totalPages }">
                <a class="page-link" href="#" aria-label="Next" @click.prevent="changePage(pageIndex + 1)">
                  <i class="flaticon-chevron"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </template>
  
  <script>
  import Lightbox from '@/components/Common/LightboxWrapper.vue';
  import HSuiteApiService from '@/core/services/hsuiteApi.service'
  import { GetTaskTypesByFilter,DeleteTaskType } from '@/core/services/entities/task.service'
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';
  import { mapGetters} from 'vuex'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'

  export default {
    name: "TaskTypeList",
    data() {
      return {
        taskTypes: [], 
        searchQuery: "", 
        filteredTaskTypes: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalTaskTypes: 0, 
        totalPages: 1, 
        showUpdateLightbox : false,
        selectedTaskType : {}
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchTaskTypes(filter = "") {
        let data = await GetTaskTypesByFilter(filter,this.pageSize,this.pageIndex);
        if(data)
        {
          this.filteredTaskTypes = data.taskTypes;
          this.totalTaskTypes = data.totalTaskTypes;
          this.totalPages = Math.ceil(this.totalTaskTypes / this.pageSize);
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchTaskTypes(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchTaskTypes(this.searchQuery);
        }
      },
      openTaskCustomFieldPage(taskTypeId) {
        this.$router.push({
          name: 'TaskCustomFieldListPage',
          params: {
            taskTypeId: taskTypeId
          }
        });
      },
      async deleteTaskType(taskTypeId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: taskTypeId };
              let response = await DeleteTaskType(payload);  
              if (response.status === 200) {
                toast.success('Task Custom Field deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchTaskTypes();
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              toast.error(`Failed to delete task custom field: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Task Custom Field deletion canceled.', { timeout: 2000 });
          }
        });

      },
    },
    computed:{...mapGetters(['allowAdd'])},
    created() {
      this.fetchTaskTypes();
    }
  };
  </script>


  